import { Container, Row, Col, Form, Button } from "react-bootstrap";

const ProfileSummaryCard = ({
  form,
  setForm,
  errors,
  isEditing,
  setIsEditing,
  primaryExperience,
  loading,
  onSave,
  onCancel,
  avatarUrl,
  onFileChange,
}) => {
  return (
    <div className="profile-summary-card">
      {/* AVATAR + UPLOAD RIGHT */}
      <div className="avatar-row-wrapper">
        <img src={avatarUrl} alt="Avatar" className="summary-avatar" />

        {isEditing && (
          <div className="avatar-upload-right">
            <label className="change-photo-label">Change photo</label>
            <input
              type="file"
              accept="image/*"
              className="change-photo-input"
              onChange={onFileChange}
            />
          </div>
        )}
      </div>

      <Container>
        <Row className="align-items-center">
          {/* NAME + TITLE */}
          <Col md={8}>
            <div
              className={isEditing ? "name-section editing" : "name-section"}
            >
              {!isEditing ? (
                <>
                  <h1 className="profile-name">
                    {form.firstName} {form.lastName}
                  </h1>
                  <p className="profile-title">
                    {primaryExperience?.jobTitle || "Member"}
                  </p>
                </>
              ) : (
                <>
                  <Row className="mb-2">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>First Name *</Form.Label>
                        <Form.Control
                          type="text"
                          value={form.firstName}
                          isInvalid={!!errors.firstName}
                          onChange={(e) =>
                            setForm((prev) => ({
                              ...prev,
                              firstName: e.target.value,
                            }))
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Last Name *</Form.Label>
                        <Form.Control
                          type="text"
                          value={form.lastName}
                          isInvalid={!!errors.lastName}
                          onChange={(e) =>
                            setForm((prev) => ({
                              ...prev,
                              lastName: e.target.value,
                            }))
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <p className="profile-title">
                    {primaryExperience?.jobTitle || "Member"}
                  </p>
                </>
              )}
            </div>
          </Col>

          {/* EDIT BUTTONS */}
          <Col
            md={4}
            className="d-flex justify-content-md-end justify-content-start"
          >
            {!isEditing ? (
              <button
                className="edit-top-btn text-primary"
                onClick={() => setIsEditing(true)}
              >
                Edit
              </button>
            ) : (
              <div className="edit-btn-row">
                <Button
                  variant="primary"
                  onClick={onSave}
                  disabled={loading}
                  className="me-2"
                >
                  Save
                </Button>
                <Button variant="outline-secondary" onClick={onCancel}>
                  Cancel
                </Button>
              </div>
            )}
          </Col>
        </Row>

        {/* META ROW */}
        <Row className="summary-meta-row">
          <Col md={4} className="summary-meta-item">
            <div className="meta-label">Location</div>
            <div className="meta-value">{form.address.city || "Not added"}</div>
          </Col>

          <Col md={4} className="summary-meta-item">
            <div className="meta-label">Career Stage</div>
            <div className="meta-value">
              {primaryExperience?.jobTitle || "Member"}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProfileSummaryCard;
